import {Race} from "./race";
import {Organiser} from "./organizer";
import {CompetitorCount} from "./competitor-count";
import {EventPaymentSettings} from "./event-payment-settings";
import {PhoneNumber} from "./phone-number";
import {RaceStartItem} from "./measurement/race-start-item";
import {LeagueTemplateEventStatus} from "./league/league-template-event-status";
import {LeagueEventType} from "./league-event-type";
import {RaceStatus} from "./race-status";
import {MultiLangField} from "./multi-lang-field";

export class EventItem {
  id?: number;
  organiserId?: number;
  measurerId?:number;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  nameSr?: string;
  nameBs?: string;
  nameShort?: MultiLangField;
  status?: number;
  start?: Date;
  end?: Date;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  created?: Date;
  modified?: Date;
  startTo?: Date;
  racesList?: Race[];
  finished?: boolean;
  open?: boolean;
  competitorCount?: CompetitorCount;
  organiser?: Organiser;
  latitude?: number;
  longitude?: number;
  defaultLanguage?: number;
  currency?: number;
  country?: number;
  city?: string;
  sportOne?: number;
  sportTwo?: number;
  extraLanguages?: number[];
  round?: number;
  eventType?: number;
  eventTags?: string[];
  locationExtraTag?: string;
  titleImage?: string;
  paymentSettings?: EventPaymentSettings;
  originalEventId?: number;
  description?: string;
  descriptionEng?: string;
  descriptionSlo?: string;
  descriptionSr?: string;
  descriptionBs?: string;
  descriptionIta?: string;
  descriptionImage?: string;
  rules?: string;
  rulesEng?: string;
  rulesSlo?: string;
  rulesSr?: string;
  rulesBs?: string;
  rulesIta?: string;
  rulesImage?: string;
  discountApplied?: boolean;
  lengths?: string[];
  measurementByStotinka?: boolean;
  phoneNumbers?: PhoneNumber[];
  awardFund?: string;
  awardFundEng?: string;
  awardFundIta?: string;
  awardFundSlo?: string;
  awardFundSr?: string;
  awardFundBs?: string;
  mediaContentHor?: string;
  mediaContentHorEng?: string;
  mediaContentHorIta?: string;
  mediaContentHorSlo?: string;
  mediaContentHorSr?: string;
  mediaContentHorBs?: string;
  mediaContentVideoHor?: string;
  mediaContentVert?: string;
  mediaContentVertEng?: string;
  mediaContentVertIta?: string;
  mediaContentVertSlo?: string;
  mediaContentVertSr?: string;
  mediaContentVertBs?: string;
  mediaContentVideoVert?: string;
  infoEmail?: string;
  // Number of countries from which competitors are coming to the event
  competitorCountriesCnt?: number;
  // Number of competitors who finished the race in event
  finCompetitorCnt?: number;
  commonStartNumber?: boolean;
  startItems?: RaceStartItem[];
  visibleToOtherLeagues?: boolean;
  pendingLeague?: boolean;
  isInLeague?: boolean;
  leagueTemplateStatus?: LeagueTemplateEventStatus;
  leagueEventType?: LeagueEventType;

}

export function isFinishedEvent(item: EventItem) {
  if (!item.end) {
    return false;
  }
  const eventEndDate = new Date(item.end);
  const today = new Date();

  return eventEndDate < today;
}

export function getRegistrationClosesDays(event: EventItem | undefined): number | undefined {
  if (!event?.racesList?.length) return undefined;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const sortedRaces = [...event!.racesList!]
      .filter(r => r.raceStart)
      .sort((a, b) => new Date(a.raceStart!).getTime() - new Date(b.raceStart!).getTime());

  const nextRace = sortedRaces.find(r => new Date(r.raceStart!).getTime() >= today.getTime() && r.status === RaceStatus.REGISTRATION_OPEN);
  if (!nextRace?.registrationEnd) return undefined;

  const regEnd = new Date(nextRace.registrationEnd);
  regEnd.setHours(0, 0, 0, 0);

  const diff = Math.ceil((regEnd.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return diff >= 0 ? diff : undefined;
}
